import BetaTag from "./BetaTag";

export default BetaTag;
